<div class="wrap grid" *ngIf="connectedClients?.users.length">
    <h4>Connected Clients:</h4>
    <div class="table-header">
        <span class="w-30">First Name:</span>
        <span class="w-30">Last Name:</span>
        <span class="w-30">Email:</span>
        <span class="w-10 connections"><mat-icon class="icon">desktop_windows</mat-icon></span>
    </div>
    <ul>
        <li *ngFor="let connection of connectedClients?.users">
            <span class="w-30">{{connection.firstName}}</span>
            <span class="w-30">{{connection.lastName}}</span>
            <span class="w-30">{{connection.email}}</span>
            <span class="duplicate w-10">{{connection.connections}}</span>
        </li>
    </ul>
</div>
